import { useEffect } from 'react';
import { useZgGraphqlQuery } from '../../../hooks/useGraphqlQuery';
import { APPLICATIONS_DASHBOARD_QUERY } from '../../../constants/queries';
import useQueryVariables from '../../../hooks/useQueryVariables';
import { Flex, Page, PageBreadcrumb, PageContent, Spinner, TextButton } from '@zillow/constellation';
import Address from './Address';
import InvitedSection from './InvitedSection';
import ApplicationSection from './ApplicationSection';
import ArchivedApplicationsList from '../../../components/ArchivedApplicationsList';
import { Link } from 'react-router-dom';
import { ZTSS_PROPERTIES } from '../../../constants/paths';
import { useSyncListing } from '../TenantScreeningServicesPage.utils';
import { useListingUser } from '../../../hooks/useListingUser';
import { emitZtssDashboardEvent } from '../../../../client/analytics/clickstreamEvents';

export default function DashboardPage() {
  const { propertyId } = useQueryVariables();
  const { isSynced } = useSyncListing();
  const { user, listing } = useListingUser();
  const { data, isLoading } = useZgGraphqlQuery(
    APPLICATIONS_DASHBOARD_QUERY,
    { listingAlias: propertyId },
    { enabled: isSynced },
  );

  useEffect(() => {
    emitZtssDashboardEvent(listing, user);
  }, []);

  if ((isLoading && !data) || !isSynced) {
    return (
      <Page>
        <PageContent>
          <Flex display="flex" alignItems="center" justifyContent="center">
            <Spinner size="lg" />
          </Flex>
        </PageContent>
      </Page>
    );
  }
  return (
    <Page>
      <PageBreadcrumb
        backButton={
          <TextButton as={Link} buttonType="primary" to={ZTSS_PROPERTIES}>
            All properties
          </TextButton>
        }
      />
      <PageContent>
        <Address data={data} />
      </PageContent>
      <PageContent>
        <InvitedSection data={data} />
      </PageContent>
      <PageContent>
        <ApplicationSection
          data={data}
          overallStatuses={new Set(['approved', 'submitted'])}
          header="Completed applications"
        />
      </PageContent>
      <PageContent>
        <ApplicationSection
          data={data}
          overallStatuses={new Set(['partially_submitted'])}
          header="Applications in progress"
        />
      </PageContent>
      <PageContent>
        <ArchivedApplicationsList />
      </PageContent>
    </Page>
  );
}
